<template>
  <div :class="wrapperClass">
    <label :for="fieldName">
      <span>{{ fieldLabel }}</span>
      <span v-if="isRequired" class="text-danger">*</span>
    </label>
    <input
      :class="classInput"
      :id="fieldName"
      :type="fieldType"
      v-model="myValue"
      :placeholder="inputPlaceholder"
      :disabled="fieldDisabled"
      :autocomplete="autocomplete"
    />
    <small class="form-text text-muted" v-if="tooltipInfo">{{
      tooltipInfo
    }}</small>
  </div>
</template>

<script>
import formComponent from "./formComponent";

export default {
  name: "FormInput",
  mixins: [formComponent],
  props: {
    wrapperClass: {
      type: String,
      default: "form-group",
    },
    fieldName: {
      type: String,
      default: "",
    },
    fieldLabel: {
      type: String,
      default: "",
    },
    fieldType: {
      type: String,
      default: "text",
    },
    fieldValue: {
      type: [String, Number, Date],
      default: "",
    },
    inputPlaceholder: {
      type: String,
      default: "",
    },
    fieldDisabled: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: String,
      default: "",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    tooltipInfo: {
      type: String,
      default: "",
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      myValue: "",
    };
  },
  computed: {
    classInput() {
      var classExtraInput = this.hasError ? "is-invalid" : "";
      return `form-control ${classExtraInput}`;
    },
  },
};
</script>
